import helper from "../../../urls/helper";
import surveying from "../../../urls/roles/surveying";

import {
    makeDeleteRequest,
    makeGetRequest,
    sendPatchRequest,
    makeParticalUpdateRequest,
    makePostRequest, sendDeleteRequest,
    sendGetRequest, sendPostRequest, finalizeRequest
} from "../../../helper/requests";
import watcher from "../../../urls/roles/watcher";
import router from "../../../router";
import names from "../../../modules/watcher/routers/names";
import creator from "../../../urls/roles/creator";
import surveys from "@/urls/roles/admin";

const state = {
    stages: [],
}

const getters = {

}

const mutations = {
    set_stages: (state, data) => {
      /**
       * Устанавливает список этапов опроса
       */
        state.stages = data
    },
}

const actions = {
    loadSurveyList: ({commit}, {url, finalizer, catcher}) => {
      /**
       * Загружает список опросов для наблюдения
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url) url = watcher.WATCHER.SURVEY.LIST()
        sendGetRequest(url, (data) => finalizer(data, url), catcher)
    },
    loadSurveyDetail: ({commit, getters}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию об опросе для наблюдения
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {number} id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.SURVEY.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadStageList: ({commit}, {survey_id, finalizer, catcher}) => {
      /**
       * Загружает список этапов опроса для наблюдения
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.STAGE.LIST(survey_id,{'size': 100})
        sendGetRequest(url,
            (data) => {
                commit('set_stages', data)
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
    loadStatisticFile: ({commit}, {id,get, finalizer, catcher}) => {
      /**
       * Загружает статистический файл по опросу
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор опроса
       * @param {Object} get - Параметры фильтрации статистики
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.FILE.UNLODING(id, get)
        sendGetRequest(
            url,
            finalizer,
            catcher
        )
    },
    loadAttemptList: ({commit}, {url, finalizer, catcher}) => {
      /**
       * Загружает список попыток прохождения опроса
       * @param {Object} context - Контекст Vuex
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url) url = watcher.WATCHER.ATTEMPT.LIST()
        sendGetRequest(url, (data) => finalizer(data, url), catcher)
    },
    loadAttemptDetail: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию о конкретной попытке
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.ATTEMPT.DETAIL(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadAttemptStageList: ({commit}, {id, finalizer, catcher}) => {
      /**
       * Загружает список этапов для конкретной попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.ATTEMPT.STAGES(id)
        sendGetRequest(url, finalizer, catcher)
    },
    loadAttemptStageFieldList: ({commit}, {id, stage_id, finalizer, catcher}) => {
      /**
       * Загружает поля и ответы для этапа конкретной попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.ATTEMPT.FIELDS(id, stage_id)
        sendGetRequest(url, finalizer, catcher)
    },

    listStageField: ({commit}, {survey_id, stage_id, finalizer, catcher}) => {
      /**
       * Загружает список полей для этапа опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let url = watcher.WATCHER.STAGE_FIELDS.LIST(survey_id, stage_id,{'size': 100})
        sendGetRequest(url,
            (data) => {
                if (finalizer) finalizer(data)
            },
            (error_data) => {
                if (catcher) catcher(error_data)
            }
        )
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
